(function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  const ACTIVE_CLASS = 'press-logos-marquee-active';

  let storedContent = null;
  let isMarqueeActive = false;
  let activeWrapper = null;

  function debounce(fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function getPressLogosWrapper() {
    return document.querySelector('.section-content-wrapper[data-section-link*="pages/media"]');
  }

  function storeOriginalContent(wrapper) {
    if (storedContent || !wrapper.querySelector('.image-block')) return;
    storedContent = wrapper.innerHTML;
  }

  function enableMarquee(wrapper) {
    storeOriginalContent(wrapper);

    const images = Array.from(wrapper.querySelectorAll(':scope > .image-block'));
    if (!images.length) return;

    const marquee = document.createElement('div');
    marquee.className = 'press-logos-marquee';

    const track = document.createElement('div');
    track.className = 'press-logos-marquee__track';

    const contentPrimary = document.createElement('div');
    contentPrimary.className = 'press-logos-marquee__content';

    const contentDuplicate = document.createElement('div');
    contentDuplicate.className = 'press-logos-marquee__content';
    contentDuplicate.setAttribute('aria-hidden', 'true');

    images.forEach((imageBlock) => {
      contentPrimary.appendChild(imageBlock);
      contentDuplicate.appendChild(imageBlock.cloneNode(true));
    });
    track.append(contentPrimary, contentDuplicate);
    marquee.appendChild(track);

    wrapper.replaceChildren(marquee);
    wrapper.classList.add(ACTIVE_CLASS);
    activeWrapper = wrapper;
    isMarqueeActive = true;
  }

  function disableMarquee(wrapper) {
    if (!storedContent) return;

    wrapper.innerHTML = storedContent;
    wrapper.classList.remove(ACTIVE_CLASS);
    activeWrapper = null;
    isMarqueeActive = false;
  }

  function updateMarquee() {
    const wrapper = getPressLogosWrapper();
    if (!wrapper) return;

    const isMobile = window.matchMedia(MOBILE_QUERY).matches;

    if (isMobile && !isMarqueeActive) {
      enableMarquee(wrapper);
      return;
    }

    if (!isMobile && isMarqueeActive && activeWrapper) {
      disableMarquee(activeWrapper);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMarquee);
  } else {
    updateMarquee();
  }

  window.addEventListener('resize', debounce(updateMarquee, 200));
})();
